import { Pipe, type PipeTransform } from '@angular/core';
import { formatFileSize } from '../format-file-size';

@Pipe({
  name: 'formatFileSize',
})
export class FormatFileSizePipe implements PipeTransform {
  transform(bytes: number | null | undefined): string {
    return formatFileSize(bytes);
  }
}
